<template>
  <div>
    <div class="ml90" v-html="getLanguage == 'zh' ? businessSpecificationObj?.specificationCn : businessSpecificationObj?.specification"></div>
  </div>
</template>

<script>
import { getAction } from "@/api/common";
import { mapGetters } from "vuex";
export default {
  props: {
    country: {
      type: String,
      default: "",
    },
    businessType: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      businessSpecificationList: [], // 说明列表
      businessSpecificationObj: {},
    };
  },
  computed: {
    ...mapGetters("language", ["getLanguage"]),
  },
  watch: {
    country: {
      handler(newVal, oldVal) {
        // 只有当 newVal 有值，且真正发生改变时才执行
        if (newVal && newVal !== oldVal) {
          this.businessSpecificationChange();
        }
      },
      immediate: true, // 确保如果父组件同步传值，初始也能捕获
    },
    businessType: {
      handler(newVal, oldVal) {
        // 只有当 newVal 有值，且真正发生改变时才执行
        if (newVal && newVal !== oldVal) {
          this.businessSpecificationChange();
        }
      },
      immediate: true, // 确保如果父组件同步传值，初始也能捕获
    },
  },
  methods: {
    // 获取banner详情
    getBannerDetail() {
      getAction("/stBusinessSpecification/getList", {})
        .then(res => {
          const resData = res.data || [];
          this.businessSpecificationList = resData;
          // 设置底部说明banner
          this.businessSpecificationChange();
        })
        .catch(err => {});
    },
    // 设置底部说明banner
    businessSpecificationChange() {
      const businessSpecificationListCopy = JSON.parse(JSON.stringify(this.businessSpecificationList));
      this.businessSpecificationObj = businessSpecificationListCopy.find(item => item.businessType === this.businessType && item.country === this.country);
    },
  },
  created() {
    this.getBannerDetail();
  },
};
</script>

<style lang="scss" scoped></style>
